import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {FabricService} from 'src/app/services/fabric/fabric.service';

const SERVICE_NAME = 'mgmt-scheduler-resources';


@Injectable({
  providedIn: 'root'
})
export class SchedulerService {

  constructor(private fabricService: FabricService) {}

  getSchedules(tenantId?: string, size?: string): Observable<any> {
    return this.fabricService.invokeOperation<any>(SERVICE_NAME, 'get_mgmt_tenants_tenantid_schedules', {tenantId, size});
  }

  getScheduleDetails(tenantId: string, id: string): any {
    return this.fabricService.invokeOperation<any>(SERVICE_NAME, 'get_mgmt_tenants_tenantid_schedules_id', {tenantId, id});
  }

  getScheduleHistory(tenantId: string, scheduleId?: string, size?: number): Observable<any> {
    return this.fabricService.invokeOperation<any>(SERVICE_NAME, 'get_mgmt_tenants_tenantid_jobs', {tenantId, scheduleId, size});
  }

  getScheduleHistoryId(tenantId: string, id: string, size?: number): Observable<any> {
    return this.fabricService.invokeOperation<any>(SERVICE_NAME, 'get_mgmt_tenants_tenantid_jobs_id', {tenantId, id, size});
  }

  getScheduleById(tenantId?: string, id?: string): Observable<any> {
    return this.fabricService.invokeOperation<any>(SERVICE_NAME, 'get_mgmt_tenants_tenantid_schedules_id', {tenantId, id});
  }

  putSchedulerById(data): Observable<any> {
    return this.fabricService.invokeOperation<any>(SERVICE_NAME, 'put_mgmt_tenants_tenantid_schedules_id', data);
  }

  deleteSchedule(tenantId: string, id: string): any {
    return this.fabricService.invokeOperation<any>(SERVICE_NAME, 'delete_mgmt_tenants_tenantid_schedules_id', {tenantId, id});
  }

  scheduleDisable(tenantId: string, id: string): any {
    return this.fabricService.invokeOperation<any>(SERVICE_NAME, 'put_mgmt_tenants_tenantid_schedules_id_disable', {tenantId, id});
  }

  scheduleEnable(tenantId: string, id: string): any {
    return this.fabricService.invokeOperation<any>(SERVICE_NAME, 'put_mgmt_tenants_tenantid_schedules_id_enable', {tenantId, id});
  }

  }
